// extracted by mini-css-extract-plugin
module.exports = {"clinicList":"ClinicList_clinicList__GJJIM","clinicListItems":"ClinicList_clinicListItems__UL3WN"};